var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('MusicStreaming'),_c('Albums'),_c('VideoStreaming')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }